import { render } from "./wattMinModal.vue?vue&type=template&id=24e301f3&ts=true"
import script from "./wattMinModal.vue?vue&type=script&lang=ts"
export * from "./wattMinModal.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__